import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles//AdminChooseus.css";

const API="/api/chooseus";

const AdminChooseus=()=>{

const [header,setHeader]=useState("");
const [slogan,setSlogan]=useState("");
const [image,setImage]=useState(null);
const [preview,setPreview]=useState("");

const [editSection,setEditSection]=useState(false);

const [points,setPoints]=useState([]);
const [descr,setDescr]=useState("");
const [editId,setEditId]=useState(null);


/* LOAD */

useEffect(()=>{
fetchSection();
fetchPoints();
},[]);


/* SECTION */

const fetchSection=async()=>{

const res=await axios.get(`${API}/section`);

setHeader(res.data.header||"");
setSlogan(res.data.slogan||"");

if(res.data.image){
setPreview(`${BASE_URL}/uploads/chooseus/${res.data.image}`);
}

};


const updateSection=async(e)=>{

e.preventDefault();

const formData=new FormData();

formData.append("header",header);
formData.append("slogan",slogan);

if(image){
formData.append("image",image);
}

await axios.put(`${API}/section/update`,formData);

alert("Section Updated");

setEditSection(false);

fetchSection();

};


/* POINTS */

const fetchPoints=async()=>{

const res=await axios.get(API);

setPoints(res.data);

};


const handleSubmit=async(e)=>{

e.preventDefault();

if(editId){

await axios.put(`${API}/update/${editId}`,{descr});

alert("Point Updated");

}else{

await axios.post(`${API}/add`,{descr});

alert("Point Added");

}

setDescr("");
setEditId(null);

fetchPoints();

};


const resetPoints=()=>{

setDescr("");
setEditId(null);

};


const editPoint=(p)=>{

setDescr(p.descr);
setEditId(p.id);

window.scrollTo({ top: 0, behavior: "smooth" });

};


const deletePoint=async(id)=>{

if(!window.confirm("Delete this point?")) return;

await axios.delete(`${API}/delete/${id}`);

fetchPoints();

};


/* MOVE */

const updateOrder=async(newList)=>{

setPoints(newList);

await axios.post(`${API}/reorder`,{
points:newList
});

};


const moveUp=(index)=>{

if(index===0) return;

const newList=[...points];

[newList[index-1],newList[index]]=
[newList[index],newList[index-1]];

updateOrder(newList);

};


const moveDown=(index)=>{

if(index===points.length-1) return;

const newList=[...points];

[newList[index+1],newList[index]]=
[newList[index],newList[index+1]];

updateOrder(newList);

};


/* UI */

return(

<div className="adminChooseus">

<h2 className="adminTitle">Why To Be Northanian Management</h2>


{/* SECTION */}

<div className="sectionCard">

<h3>Section Settings</h3>

{!editSection && (

<button
className="btnEditSection"
onClick={()=>setEditSection(true)}
>
Edit Section
</button>

)}

{editSection && (

<form onSubmit={updateSection}>

<label>Header</label>

<input
type="text"
value={header}
onChange={(e)=>setHeader(e.target.value)}
/>

<label>Slogan</label>

<input
type="text"
value={slogan}
onChange={(e)=>setSlogan(e.target.value)}
/>

<label>Image</label>

<input
type="file"
onChange={(e)=>setImage(e.target.files[0])}
/>

{preview && <img src={preview} className="preview" alt="" />}

<div className="btnRow">

<button className="btnSave">Update</button>

<button
type="button"
className="btnReset"
onClick={()=>{fetchSection();setEditSection(false);}}
>
Reset
</button>

</div>

</form>

)}

</div>


{/* POINTS */}

<div className="pointsCard">

<h3>Points Manager</h3>

<form onSubmit={handleSubmit}>

<textarea
placeholder="Enter description"
value={descr}
onChange={(e)=>setDescr(e.target.value)}
/>

<div className="btnRow">

<button className="btnAdd">
{editId ? "Update Point" : "Add Point"}
</button>

<button
type="button"
className="btnReset"
onClick={resetPoints}
>
Reset
</button>

</div>

</form>


<table className="pointsTable">

<thead>

<tr>
<th>No</th>
<th>Description</th>
<th>Move</th>
<th>Action</th>
</tr>

</thead>

<tbody>

{points.map((p,index)=>(

<tr key={p.id}>

<td>{index+1}</td>

<td>{p.descr}</td>

<td>

<button
className="moveBtn"
onClick={()=>moveUp(index)}
>
▲
</button>

<button
className="moveBtn"
onClick={()=>moveDown(index)}
>
▼
</button>

</td>

<td>

<button
className="btnEdit"
onClick={()=>editPoint(p)}
>
Edit
</button>

<button
className="btnDelete"
onClick={()=>deletePoint(p.id)}
>
Delete
</button>

</td>

</tr>

))}

</tbody>

</table>

</div>

</div>

);

};

export default AdminChooseus;